export const dummyTopics = [
  {
    id: 1,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 2,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 3,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 4,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 5,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 6,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 7,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 8,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 9,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 10,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 11,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
  {
    id: 12,
    title: "My Topic",
    description: "All materials about this topic",
    link: "View here",
  },
];
